<template>
  <el-card class="input-group-dark border-black bg-white">
    <template #header>
      <div class="card-header">
        <span class="text-black font-bold title">{{ title }}</span>
      </div>
    </template>
    <slot></slot>
  </el-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
})
</script>

<style scoped lang="scss">
.input-group {
  ::v-deep(.el-card__header) {
    font-weight: bold;
    border-bottom: initial;
    font-size: 1.25em;
    padding-bottom: 0px;
  }
}
</style>
